import { useStores } from "core/stores";
import { observer } from "mobx-react-lite";
import React, { useState, useEffect, Fragment, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
//import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { IADUser } from "common/interfaces/IADUser";
import { Spinner } from "components/common/Spinner";
import "react-data-grid/lib/styles.css";

import ReactDataGrid, { Column } from "react-data-grid";
import { WorkflowType } from "common/enums/WorkflowType";

interface AddWorkflowProp {
    children: JSX.Element;
}

export const AddWorkflow = observer((props: AddWorkflowProp) => {

    const  navigate  = useNavigate();
    const [workflowName, setWorkflowName] = useState<string>("");

    const [isWorkflowNameValid, setIsWorkflowNameValid] = useState<boolean>(true);

    const [workflowTypeSelection, setWorkflowTypeSelection] = React.useState<string | undefined>("");

    const [isWorkflowTypeValid, setIsWorkflowTypeValid] = useState<boolean>(true);

    const onWorkflowNameChange = (e: any) => {
        setWorkflowName(e.target.value);
    };

    const validate = () => {
        let isValid = true;
        isValid = workflowName.length < 1 ? false : true;
        setIsWorkflowNameValid(isValid);
        if (!isValid) return false;
        isValid = workflowTypeSelection ? true : false;
        setIsWorkflowTypeValid(isValid);
        if (!isValid) return false;
        return isValid;
    };

    const onCancelClick = () => {
        navigate("/workflows");
    };

    const onCreateHandle = () => {
        if(validate())
        {
            navigate(`/newworkflow/${workflowName}/${workflowTypeSelection}`);
        }
    };

    const handleUserTypeSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setWorkflowTypeSelection(e.target.value as string);
    };

    return (
        <div className="container-fluid p-1">
            <div className="m-4 card">
                <div className="card-header">
                    <div className="row">
                        <div className="col-6 align-content-center">
                            <h1>Workflow Configuration</h1>
                        </div>
                    </div>
                </div>
                <div className="row card-body w-100 h-100">
                    <form className="needs-validation">
                        <div className="form-group row pb-2">
                            <label htmlFor="name" className="col-md-2 col-form-label">
                                Workflow Name
                            </label>
                            <div className="col-md-4">
                                <input
                                    type="name"
                                    name="name"
                                    required
                                    value={workflowName}
                                    onChange={onWorkflowNameChange}
                                    className={isWorkflowNameValid ? "form-control" : "form-control is-invalid"}
                                    id="inputName"
                                    placeholder="Name"
                                />
                            </div>
                        </div>
                        <div className="form-group row pb-2">
                            <label htmlFor="name" className="col-md-2 col-form-label">
                                Workflow Type
                            </label>
                            <div className="col-md-4">
                                <select
                                    value={workflowTypeSelection}
                                    required
                                    onChange={(e) => handleUserTypeSelectionChange(e)}
                                    className={isWorkflowTypeValid ? "form-control" : "form-control is-invalid"}
                                    name="userType"
                                >
                                    <option selected={true} value={""}>
                                        Select Workflow Type
                                    </option>
                                    <option value={"1"}>Price Claim</option>
                                    <option value={"2"}>Inventory/Uplift/RMA</option>
                                    <option value={"3"}>Ad hoc</option>                                    
                                </select>
                            </div>
                        </div>
                        <div className="form-group row button-row-margin">
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={onCreateHandle} type="button">
                                    Create
                                </button>
                                <a className="btn btn-primary ms-1" onClick={onCancelClick}>
                                    Cancel
                                </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
});
